import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronUpOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m8 4.5 5 5-.99.99L8 6.48l-4.01 4.01L3 9.5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronUpOutlinedSize16Glyph.displayName = 'ChevronUpOutlinedSize16Glyph';
